import RequiredValidator from "@/validators/RequiredValidator";
import {RangeValidator} from "@/validators/RangeValidator";
import {enumToArray} from "@/helpers/functions_asi";
import {BillState} from "@/helpers/constants";
import {NumberValidator} from "@/validators/NumberValidator";

export default class BillRules {

	public static readonly nameRules = [
		(new RequiredValidator('bill.name')).validationRule(),
	];

	public static readonly stateRules = [
		(new RequiredValidator('bill.state')).validationRule(),
		(new RangeValidator('bill.state', false, enumToArray(BillState).map(b => b.value))).validationRule(),
	];

	public static readonly companyIdRules = [
		(new RequiredValidator('company.singular')).validationRule(),
	];

	public static readonly billingDateRules = [
		(new RequiredValidator('bill.billingDate')).validationRule(),
	];

	public static readonly numberRules = [
		(new NumberValidator('bill.number')).validationRule(),
	];

	public static readonly isPaidRules = [
		(new RequiredValidator('bill.isPaid')).validationRule(),
	];

}
